import React, { useState, useEffect } from 'react';
import { Image } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { ImageType } from '@typings/Image';

interface ListImagesProps {
  images: ImageType[];
  removeImage: (id: number) => void;
}

const ImageWithIcon: React.FC<{
  image: ImageType;
  removeImage: (id: number) => void;
}> = ({ image, removeImage }) => {
  const [showCloseIcon, setShowCloseIcon] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowCloseIcon(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div key={image.id} className="pl-3 relative inline-block">
      <Image height={100} src={image.previewUrl} />
      {showCloseIcon && image.previewUrl && (
        <CloseCircleOutlined
          onClick={() => image.id !== undefined && removeImage(image.id)}
          className="absolute top-1 right-1 cursor-pointer bg-white rounded-lg"
        />
      )}
    </div>
  );
};

const ListImages: React.FC<ListImagesProps> = ({ images, removeImage }) => {
  return (
    <div className="flex gap-3 flex-wrap overflow-y-scroll max-h-56">
      {images.map(image => (
        <ImageWithIcon key={image.id} image={image} removeImage={removeImage} />
      ))}
    </div>
  );
};

export default ListImages;
